// extracted by mini-css-extract-plugin
export default {"enrollmentIcon":"Enrollment_enrollmentIcon__99j-X","container":"Enrollment_container__IButA","uploadBtn":"Enrollment_uploadBtn__pJri5"};